<h3 class="font-size-3 mb-3">{{ 'lombard.status.headline' | transloco }}</h3>
@if (facade.lombard$ | async; as lombard) {
  @switch (lombard.lombardDataStatus) {
    @case ('WAITING_FOR_BANK_APPROVEMENT') {
      <div class="tile" data-zid="lombard-status-WAITING_FOR_BANK_APPROVEMENT">
        <h3 class="mb-3 font-size-3">{{ 'lombard.status.WAITING_FOR_BANK_APPROVEMENT.headline' | transloco }}</h3>
        <div class="text-size-large">{{ 'lombard.status.WAITING_FOR_BANK_APPROVEMENT.body' | transloco }}</div>
      </div>
      <div class="tile">
        <div class="data-holder">
          <div>
            <div class="label">{{ 'lombard.status.WAITING_FOR_BANK_APPROVEMENT.data.requestedCreditAmount' | transloco }}</div>
            <div class="value disabled">{{ lombard.requestedCreditAmount | number: '1.0-0' }}<sub>€</sub></div>
          </div>
          @if (lombard.currentCreditAmount) {
            <div class="spacer"></div>
            <div>
              <div class="label">{{ 'lombard.status.WAITING_FOR_BANK_APPROVEMENT.data.currentCreditAmount' | transloco }}</div>
              <div class="value disabled">{{ lombard.currentCreditAmount | number: '1.2-2' }}<sub>€</sub></div>
            </div>
          }
          <div class="spacer"></div>
          <div>
            <div class="label">{{ 'lombard.status.WAITING_FOR_BANK_APPROVEMENT.data.currentUsedCreditAmount' | transloco }}</div>
            <div class="value disabled">{{ lombard.currentUsedCreditAmount | number: '1.2-2' }}<sub>€</sub></div>
          </div>
          <div class="spacer"></div>
          <div>
            <div class="label">{{ 'lombard.status.WAITING_FOR_BANK_APPROVEMENT.data.state' | transloco }}</div>
            <div class="value">{{ 'lombard.status.WAITING_FOR_BANK_APPROVEMENT.data.state-text' | transloco }}</div>
          </div>
        </div>
      </div>
    }
    @case ('WAITING_FOR_CUSTOMER_ACCEPTANCE') {
      <lombard-confirmation-reminder data-zid="lombard-status-WAITING_FOR_CUSTOMER_ACCEPTANCE" />
    }
    @case ('CUSTOMER_ACCEPTED') {
      <div class="tile" data-zid="lombard-status-CUSTOMER_ACCEPTED">
        <h3 class="mb-3 font-size-3">{{ 'lombard.status.CUSTOMER_ACCEPTED.headline' | transloco }}</h3>
        <div class="text-size-large">{{ 'lombard.status.CUSTOMER_ACCEPTED.body' | transloco }}</div>
      </div>
      <div class="tile">
        <div class="data-holder">
          <div>
            <div class="label">{{ 'lombard.status.CUSTOMER_ACCEPTED.data.requestedCreditAmount' | transloco }}</div>
            <div class="value disabled">{{ lombard.requestedCreditAmount | number: '1.0-0' }}<sub>€</sub></div>
          </div>
          @if (lombard.currentCreditAmount) {
            <div class="spacer"></div>
            <div>
              <div class="label">{{ 'lombard.status.CUSTOMER_ACCEPTED.data.currentCreditAmount' | transloco }}</div>
              <div class="value disabled">{{ lombard.currentCreditAmount | number: '1.2-2' }}<sub>€</sub></div>
            </div>
          }
          <div class="spacer"></div>
          <div>
            <div class="label">{{ 'lombard.status.CUSTOMER_ACCEPTED.data.currentUsedCreditAmount' | transloco }}</div>
            <div class="value disabled">{{ lombard.currentUsedCreditAmount | number: '1.2-2' }}<sub>€</sub></div>
          </div>
          <div class="spacer"></div>
          <div>
            <div class="label">{{ 'lombard.status.CUSTOMER_ACCEPTED.data.creditInterest' | transloco }}</div>
            <div class="value disabled">{{ lombard.creditInterest | number: '1.0-2' }}<sub>%</sub></div>
          </div>
          <div class="spacer"></div>
          <div>
            <div class="label">{{ 'lombard.status.CUSTOMER_ACCEPTED.data.state' | transloco }}</div>
            <div class="value">{{ 'lombard.status.CUSTOMER_ACCEPTED.data.state-text' | transloco }}</div>
          </div>
        </div>
      </div>
    }
    @case ('ACTIVE') {
      <div class="tile" data-zid="lombard-status-ACTIVE">
        <div class="data-holder justify-content-between">
          <div class="d-flex">
            <div class="d-flex flex-column justify-content-between">
              <div class="label">{{ 'lombard.status.ACTIVE.data.currentCreditAmount' | transloco }}</div>
              <div class="value">{{ lombard.currentCreditAmount | number: '1.0-0' }}<sub>€</sub></div>
            </div>
            <div class="spacer"></div>
            <div class="d-flex flex-column justify-content-between">
              <div class="label" [ngClass]="lombard.lombardWarninglevel">
                {{ 'lombard.status.ACTIVE.data.currentUsedCreditAmount' | transloco }}
                @if (lombard.lombardWarninglevel) {
                  <svg class="icon icon-16 cursor-pointer ml-1" (click)="modal.open(warningLevelModal)">
                    <use xlink:href="/assets/img/svgs/svgset.svg#info-23" />
                  </svg>
                  <ng-template #warningLevelModal let-modal>
                    <web-design-system-modal (dismiss)="modal.dismiss('Cross click')">
                      <p>{{ 'lombard.warning-level.' + lombard.lombardWarninglevel | transloco }}</p>
                    </web-design-system-modal>
                  </ng-template>
                }
              </div>
              <div class="value">{{ lombard.currentUsedCreditAmount | number: '1.2-2' }}<sub>€</sub></div>
            </div>
            <div class="spacer"></div>
            <div class="d-flex flex-column justify-content-between">
              <div class="label">{{ 'lombard.status.ACTIVE.data.creditInterest' | transloco }}</div>
              <div class="value">{{ lombard.creditInterest | number: '1.0-2' }}<sub>%</sub></div>
            </div>
          </div>
          <div class="text-right">
            <web-design-system-button size="small" [disabled]="!lombard.creditChangePossible" (click)="editCredit()">
              {{ 'lombard.status.ACTIVE.change-credit-button' | transloco }}
            </web-design-system-button>
            <div class="mt-1">
              @if (lombard.creditDeletionPossible) {
                <a class="link-secondary cursor-pointer text-size-large" (click)="cancelCredit()">
                  {{ 'lombard.status.ACTIVE.cancel-credit' | transloco }}
                </a>
              } @else {
                <span class="text-size-large">{{ 'lombard.status.ACTIVE.cancel-credit' | transloco }}</span>
                <svg class="icon icon-16 cursor-pointer ml-1 cancel-credit" (click)="modal.open(cancelCreditModal, { size: 'lg' })">
                  <use xlink:href="/assets/img/svgs/svgset.svg#info-23" />
                </svg>
                <ng-template #cancelCreditModal let-modal>
                  <web-design-system-modal
                    [headline]="'lombard.status.ACTIVE.cancel-credit' | transloco"
                    (dismiss)="modal.dismiss('Cross click')"
                  >
                    <p>{{ 'lombard.status.ACTIVE.cancel-credit-not-possible' | transloco }}</p>
                  </web-design-system-modal>
                </ng-template>
              }
            </div>
          </div>
        </div>
      </div>
      <lombard-faqs [fatPadding]="false" />
    }
    @case ('WAITING_FOR_BANK_DELETION') {
      <div class="tile" data-zid="lombard-status-WAITING_FOR_BANK_APPROVEMENT">
        <h3 class="mb-3 font-size-3">{{ 'lombard.status.WAITING_FOR_BANK_DELETION.headline' | transloco }}</h3>
        <div class="text-size-large">{{ 'lombard.status.WAITING_FOR_BANK_DELETION.body' | transloco }}</div>
      </div>
    }
    @case ('CUSTOMER_DISMISSED') {
      <div class="tile" data-zid="lombard-status-CUSTOMER_DISMISSED">
        <h3 class="mb-3 font-size-3">{{ 'lombard.status.CUSTOMER_DISMISSED.headline' | transloco }}</h3>
        <div class="text-size-large">{{ 'lombard.status.CUSTOMER_DISMISSED.body' | transloco }}</div>
      </div>
    }
    @default {
      <div class="error-hint" data-zid="lombard-status-ERROR">
        {{ 'lombard.status.error' | transloco }}
      </div>
    }
  }
}
